import $ from 'jquery';

$(document).ready(function () {
  $('.years-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.tab-years',
    prevArrow: '.prev',
    nextArrow: '.next',
  });
  $('.tab-years').slick({
    infinite: true,
    slidesToShow: 7,
    slidesToScroll: 1,
    asNavFor: '.years-slider',
    focusOnSelect: true,
    arrows: false,
  });
});
